module.exports = __webpack_public_path__ + "img/research_item_1.2bcd57b7.png";